import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Axios from "axios";
import "./plugins/vue-mq";
import "./plugins/elementUi";
import ScreenMixins from "@/mixins/ScreenCheckMixins";
import DoesFileExists from "@/mixins/doesFileExists";
import { socketListener } from "@/mixins/socketListener";

import Default from "./layouts/Default.vue";
import Login from "./layouts/Login.vue";

Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;

Vue.component("default-layout", Default);
Vue.component("login-layout", Login);
Vue.mixin(socketListener);
Vue.mixin(ScreenMixins);
Vue.mixin(DoesFileExists);

window.Event = new Vue();

const allowCrossDomain = function(req, res, next) {
  res.header("Access-Control-Allow-Origin", "*");
  res.header("Access-Control-Allow-Methods", "*");
  res.header("Access-Control-Allow-Headers", "*");
  res.header("Access-Control-Allow-Credentials", "true");
  next();
};

new Vue({
  router,
  store,
  allowCrossDomain,
  socketListener,
  ScreenMixins,
  DoesFileExists,
  render: (h) => h(App),
}).$mount("#app");
